import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';
import { DEFAULT_INTERESTS } from '../constants/defaultInterests';
import { normalizeInterestItems } from '../utils/interestUtils';

export function useInterestCatalog() {
  const [interests, setInterests] = useState(DEFAULT_INTERESTS);
  const [loading, setLoading] = useState(true);
  const [fromFirestore, setFromFirestore] = useState(false);

  useEffect(() => {
    const ref = doc(db, 'system', 'interests');
    const unsub = onSnapshot(
      ref,
      (snap) => {
        const items = normalizeInterestItems(snap.data()?.items);
        if (items.length > 0) {
          setInterests(items);
          setFromFirestore(true);
        } else {
          setInterests(DEFAULT_INTERESTS);
          setFromFirestore(false);
        }
        setLoading(false);
      },
      (err) => {
        console.error('system/interests', err);
        setInterests(DEFAULT_INTERESTS);
        setFromFirestore(false);
        setLoading(false);
      }
    );
    return unsub;
  }, []);

  return { interests, loading, fromFirestore };
}
